<template>
    <div :class="classes()"></div>
</template>
<script>
    export default {
        props: {
            size: {
                type: String,
                default: 'md'
            },
            bordered: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            classes() {
                const sizesMap = {
                    'sm': 'my-1',
                    'md': 'my-3',
                    'lg': 'my-6',
                };

                let size = sizesMap[this.size];
                let bordered = this.bordered ? 'border-t' : '';

                return `${size} ${bordered}`;
            }
        }
    }
</script>
